"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Portal = _interopRequireDefault(require("./Portal/Portal"));

var _Overlay = _interopRequireDefault(require("./Overlay"));

var Styled = _interopRequireWildcard(require("./Layer.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Layer = function Layer(_a) {
  var children = _a.children,
      closeOnClickOutside = _a.closeOnClickOutside,
      isOpen = _a.isOpen,
      overlay = _a.overlay,
      onClose = _a.onClose,
      lockBodyScroll = _a.lockBodyScroll,
      zIndex = _a.zIndex;
  return isOpen ? React.createElement(_Portal.default, {
    onClose: onClose,
    lockBodyScroll: lockBodyScroll
  }, React.createElement(Styled.Layer, {
    zIndex: zIndex
  }, React.createElement(_Overlay.default, {
    onClick: function onClick() {
      return closeOnClickOutside && onClose();
    },
    overlay: overlay,
    "data-testid": "LayerOverlay"
  }), React.createElement(Styled.ScrollEnable, null, children))) : null;
};

Layer.displayName = 'Layer';
Layer.defaultProps = {
  closeOnClickOutside: true,
  closeOnEsc: true,
  isOpen: true,
  overlay: true
};
var _default = Layer;
exports.default = _default;